// Orders are grouped by a 'YYYY-MM-DD' string rather than a timestamp range.
// An equality query on dayKey needs no composite index and returns identical
// results from the offline cache, a createdAt range query would miss orders
// whose serverTimestamp() has not resolved yet.
//
// The key comes from the device clock, so a laptop with a wrong date files
// orders under the wrong day. POSLayout shows the date in the header to make
// that visible during setup.

export function toDayKey(date: Date = new Date()): string {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

export function formatDayKey(dayKey: string): string {
  const [y, m, d] = dayKey.split('-')
  return `${d}.${m}.${y}`
}

export function formatClock(ms: number): string {
  const dt = new Date(ms)
  return `${String(dt.getHours()).padStart(2, '0')}:${String(dt.getMinutes()).padStart(2, '0')}`
}
